import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import mathText from '../math_text.js'

const level = new Level({
    name: 'vector',
    dependencies: [
        'levels_maths/vector_x_coord',
        'levels_maths/vector_y_coord'
    ]
})


function common (q, v) {

    v.name    = 'V'
    v.originX = v.originX || 0
    v.originY = v.originY || 0
    v.color   = '#F00'

    let geoScreen = q.addGeoScreen({
        noAxes: v.noAxes,
        margin: 0.3
    })
    geoScreen.addVector(v)

    q.addText(mathText.vectorName(v) + '( ? )')
    q.answer = v.x + ';' + v.y

}


level.addQuestion({
    generator: function (q) {
        common(q, {
            x: random.fairChoiceInt(1, 5, {name: 'x'}),
            y: random.fairChoiceInt(1, 7, {name: 'y'}),
            noAxes: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            x: random.fairChoiceInt(-5, 5,  {name: 'x'}),
            y: random.fairChoiceInt(-6, -1, {name: 'y'}),
            noAxes: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            originX: random.fairChoiceInt(1, 3,  {name: 'originX'}),
            originY: random.fairChoiceInt(1, 3,  {name: 'originY'}),
            x: random.fairChoiceInt(-5, 5,  {name: 'x'}),
            y: random.fairChoiceInt(-6, -1, {name: 'y'})
        })
    },
    errorExpected: true
})


export default level

